exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\ndiv.pad[data-v-40d76655] {\n    padding: 0.85em;\n}\nhr.footpage-copyright[data-v-40d76655] {\n    margin: 2em;\n}\ndiv.footpage-copyright[data-v-40d76655] {\n    text-align: center;\n    font-size: 0.9em;\n    color: #222;\n    padding: 2em;\n}\n\n", ""]);

